import {
  formatError,
  formatSuccess,
} from '@/shared/utils/formatting/formatNotification';
import { useForm } from '@refinedev/react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@refinedev/core';
import {
  Questionnaire,
  UpdateQuestionnaire,
} from '@aphp-ema/common/questionnaire';
import { HttpError } from '@refinedev/core';
import { useParams } from 'react-router';
import { useQuestionnaireResolver } from '@/features/questionnaires/hooks/useQuestionnaireResolver';
import { useQuestionOrderSync } from '@/features/questionnaires/hooks/useQuestionOrderSync';

export const useQuestionnaireForm = (kind: 'EMA' | 'INITIAL') => {
  const { id: studyId, questionnaireId } = useParams<{
    id: string;
    questionnaireId: string;
  }>();

  const { t } = useTranslation();
  const navigate = useNavigation();

  const translationKey =
    kind === 'EMA' ? 'emaQuestionnaire' : 'initialQuestionnaire';

  const goBack = () => {
    navigate.push(`/studies/edit/${studyId}`);
  };

  const resolver = useQuestionnaireResolver(kind);

  const form = useForm<Questionnaire, HttpError, UpdateQuestionnaire>({
    resolver,
    mode: 'onChange',
    refineCoreProps: {
      resource: kind === 'EMA' ? 'ema-questionnaire' : 'initial-questionnaire',
      action: questionnaireId ? 'edit' : 'create',
      id: questionnaireId,
      successNotification: formatSuccess(
        t(`pages.studies.${translationKey}.create.success`),
      ),
      errorNotification: (error) =>
        formatError(error, t(`pages.studies.${translationKey}.create.error`)),
      onMutationSuccess: () => {
        // TODO : ugly hack : necessary to wait for the mutation to complete before navigating back
        setTimeout(() => {
          goBack();
        }, 10);
      },
      queryOptions: {
        onSuccess: () => {
          // trigger validation on load to see conditions errors
          form.trigger('questions');
        },
      },
    },
    defaultValues: {
      studyId,
      kind,
      schedule: null,
    },
  });

  useQuestionOrderSync(form);

  return { ...form, goBack, t };
};
